export default {
  primary: {
    // Green
    main: "#3CBA68",
    dark: "#2A904E",
    light: "#9DDCB3",
  },
  // Yellow
  secondary: {
    main: "#F9C028",
    dark: "#DEAB24",
    light: "#FCDF93",
  },
  // Grayscale
  text: {
    primary: "#FFFFFF",
    secondary: "#EDEDED",
    disabled: "#C6C6C6",
  },
  // Transparent
  transparent: "transparent",
  // Dark backgrounds
  background: {
    default: "#0F2C2A",
    paper: "#3A454E",
  },
  // Light green
  divider: "#224A47",
};
